<template>
    <div class="full-screen-view" :style="styleObj">
        <IslandManager />
    </div>
</template>

<script setup>
    import IslandManager from "@/components/shopopee/island/islandManager.vue";
    import {ref, onBeforeMount} from "vue";

    const styleObj = ref({})

    onBeforeMount(() => {
        styleObj.value = {
            width: `${window.innerWidth}px`,
            height: `${window.innerHeight}px`,
        }
    })
</script>

<style scoped>

.full-screen-view {
    width: 100%;
    height: 100%;
    position: relative;
    box-sizing: border-box;
}

</style>